import { backendAPI } from '../../helper/apis';

export const fetchPurchasePackages = (query) => {
  return backendAPI.get(`/packpurchase?${query}`);
}